/* eslint react-hooks/exhaustive-deps: 0 */

import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { AppBar, Box, createStyles, Grid, makeStyles, Toolbar, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Lang } from "../states/query";
import { State } from "../reducers";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { switchIsInitial } from "../actions/generalAction";
import { HelmetProvider } from "react-helmet-async";

const useStyles = makeStyles(() =>
  createStyles({
    content: {
      minHeight: '80vh',
    },
    footer: {
      top: "auto",
      bottom: 0,
      minHeight: '10vh'
    },
    notFoundHeader: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    notFoundMessage: {
      textAlign: 'center',
      fontSize: '15px'
    },
  }),
);

/** Not Found(404)用のコンポーネント。 */
export const NotFound: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const isInitial = useSelector((state: State) => state.general.isInitial);
  const classes = useStyles({});
  // リファラーを取得する。
  const referrer = useSelector((state: State) => state.general.referrer);

  // リクエストパラメーターを取得する。
  const searchParams = new URLSearchParams(location.search);
  /** リダイレクト元のパスを取得する。 */
  // リダイレクト時にState内でリダイレクト元の値を渡されている場合のみその値を設定する。
  // const redirectOrigin = location.state ? location.state.redirectOrigin : "";

  useEffect(() => {
    // アプリケーション上で最初の描画の場合のみ、言語設定をする。
    if (isInitial) {
      // 英語の場合。
      if (searchParams.get('lang') === Lang.en) {
        i18n.changeLanguage('en');
      // 英語以外（日本語）の場合。
      } else {
        i18n.changeLanguage('ja');
      }
      // 最初の描画であるフラグをfalseにする。
      dispatch(switchIsInitial(false));
    }
  }, [dispatch, i18n, isInitial, searchParams]);

  return (
    <Box>
      <HelmetProvider>
        <Helmet>
          {/* ページタイトルを設定する。 */}
          <title>{t('title')}</title>
        </Helmet>
      </HelmetProvider>
      {/* ヘッダー部分。 */}
      <AppBar position='static'>
        <Toolbar/>
      </AppBar>
      <Grid container alignContent='center' justify='center' alignItems='center' className={classes.content}>
        <Grid item>
          <Typography color='primary' className={classes.notFoundHeader}>
            { t('not_found_header') }
          </Typography>
          <Typography color='textSecondary' className={classes.notFoundMessage}>
            { t('not_found_message') }
          </Typography>
        </Grid>
      </Grid>
      {/* フッター部分。 */}
      <AppBar position="fixed" color="primary" className={classes.footer} />
    </Box>
  )
}

export default NotFound;
